<template>
  <section class="content">
      <!-- <div class="box box-info"> -->
        <!-- <form > -->
  <!-- <footer id="colophon" class="site-footer">
<div class="footer-widget">
<div class="container-full">
<div class="row">
<div class="col-sm-6 col-md-3 col-lg-3">
<div class="footer-widget__item">
<section id="nav_menu-5" class="widget widget_nav_menu">
    <h3 class="widget-title" style="margin-left: 22%;">Policies</h3><div class="menu-footer-container">
        <ul id="menu-footer" class="menu-footer"><li id="menu-item-3475" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3475"><a href="https://woollyfelt.com/return-policy/">Return Policy</a></li>
<li id="menu-item-3476" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3476"><a href="https://woollyfelt.com/shipping-policy/">SHIPPING POLICY</a></li>
<li id="menu-item-3477" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3477"><a href="https://woollyfelt.com/terms-of-service/">TERMS OF SERVICE</a></li>
<li id="menu-item-3478" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-3478"><a href="https://woollyfelt.com/privacy-policy/">Privacy Policy</a></li>
</ul></div></section>					</div>
</div>
<div class="col-sm-6 col-md-3 col-lg-3">	
<div class="footer-widget__item">
<section id="text-9" class="widget widget_text">
<div class="textwidget">
<p><img loading="lazy" class="alignnone  wp-image-506 jetpack-lazy-image"
 src="/static/img/web/woollyfeltlogo-2.png" alt="" width="183" height="47" data-recalc-dims="1" srcset="https://i0.wp.com/woollyfelt.com/wp-content/uploads/2021/01/cropped-Cdgrgergapture-removebg-preview.png?w=359&amp;ssl=1 359w, https://i0.wp.com/woollyfelt.com/wp-content/uploads/2021/01/cropped-Cdgrgergapture-removebg-preview.png?resize=300%2C77&amp;ssl=1 300w" sizes="(max-width: 183px) 100vw, 183px" /></noscript></p>
<p>Our main goal is to provide employment opportunities to home working women, underprivileged women, and women who want to generate income for their families.</p>
</div>
</section>					</div>
</div>
<div class="col-sm-6 col-md-3 col-lg-3">
<div class="footer-widget__item">
<section id="text-5" class="widget widget_text"><h3 class="widget-title">Social Links</h3>
<div class="textwidget"><p>
    <a href="https://www.facebook.com/woollyfelt">
    <img loading="lazy" src="https://i0.wp.com/woollyfelt.com/wp-content/uploads/2021/01/fb-removebg-preview.png?resize=45%2C46&ssl=1"  title="Facebook"  /></a>

<a href="https://www.facebook.com/woollyfelt">
    <img loading="lazy" src="https://i1.wp.com/woollyfelt.com/wp-content/uploads/2021/01/index-removebg-preview.png?resize=48%2C48&ssl=1"  title="Instagram"  /></a>
<a href="https://www.facebook.com/woollyfelt">
    <img loading="lazy" src="https://i1.wp.com/woollyfelt.com/wp-content/uploads/2021/04/%E2%80%94Pngtree%E2%80%94twitter-icon_3584901.png?resize=64%2C64&ssl=1"  title="Tweeter"  /></a></p>
</div>
</section>					</div>
</div>
<div class="col-sm-6 col-md-3 col-lg-3">
<div class="footer-widget__item">
<section id="text-7" class="widget widget_text"><h3 class="widget-title">Payments Gateways</h3>	
<div class="textwidget"><p><img loading="lazy"  /></p>
</div>
</section>					</div>
</div>
</div>
</div>
</div>			<div class="site-info">
<a href="https://woollyfelt.com/#">Woollyfelt 2021 All Rights Reserved</a>
<span class="sep"> | </span>
Powered by: <a href="https://raisetech.com.np/" rel="nofollow" target="_blank">Raise Tech Pvt. Ltd.</a>  .		</div>
</footer> -->
<div id="shopify-section-footer" class="shopify-section">
<footer class="site-footer" role="contentinfo">
  <div class="page-width">
    <div class="grid footer-top">
    <aside class="col-sm-6 col-md-3 col-lg-4" id="nav_menu-1532932009490" >
      <h4 class="h4" style="margin: 0% 6%;">Informations<i class="ad ad-angle-down-l medium-up--hide">
        </i></h4><ul>
          <li>
           <router-link to="/aboutUs" >
                <a href="#">About Us</a>
              </router-link>
              </li>
       <li>
           <router-link to="/privacyPolicy" >
                <a href="#">Privacy Policy</a>
              </router-link>
              </li>
              <li>
           <router-link to="/exchangeAndCancellations">
                <a href="#">Exchange & Cancellations</a>
              </router-link>
              </li>
        <!-- <li><a href="/pages/returns-cancellations">Exchange & Cancellations</a>
        </li -->
    <li>
           <router-link to="/contactUs" >
                <a href="#">Contact Us</a>
              </router-link>
              </li>
        </ul><hr class="medium-up--hide" />
        </aside>
        <aside class="col-sm-6 col-md-3 col-lg-4" id="text-1540197818915" >
          <h4 class="h4" style="margin: 0% 6%;">Contact Us</h4><ul class="addressFooter"><li><p style="margin: 0% -8%;">Kathmandu, Nepal</p></li>
          <li class="phone"><i class="ad ad-phone-l"></i><p style="margin: 0% -8%;">
              <a href="tel:+91-9911437000">+91-9911437000</a></p></li><li class="email">
                <i class="ad ad-envelope-l"></i><p style="margin: 0% -8%;"><a href="mailto:Talk.lilpicks@gmail.com">Talk.lilpicks@gmail.com</a></p></li></ul>
                </aside>
                <aside class="col-sm-6 col-md-3 col-lg-4" id="text-1600966736723" >
                  <h4 class="h4">Become a part of our family!</h4> 
                  <p>Get Parenting insights, advice, crazy stories, crazier offers + discounts! No spam, pinky promise!</p>
                   <form method="post" action="/contact#contact_form" id="contact_form" accept-charset="UTF-8" class="contact-form">
                  <input type="hidden" name="form_type" value="customer" /><input type="hidden" name="utf8" value="✓" />
                  <div class="input-group"><input type="hidden" name="contact[tags]" value="newsletter">
                  <input type="email" name="contact[email]" id="Email" class="input-group__field newsletter__input" value="" placeholder="Email address"
                   autocorrect="off" autocapitalize="off"><span class="input-group__btn"><button type="submit" class="btn newsletter__submit" name="commit" id="Subscribe">
                    <span class="newsletter__submit-text--large">Subscribe</span></button></span></div></form> 
                    </aside></div><!-- Footer Bottom --><hr /><div class="footer-bottom grid"><div class="grid--table">
                      <div class="grid__item small--text-center medium-up--one-whole text-center"><span>© 2020 LILPICKS.</span> All Rights Reserved. 
                      </div>
                      </div>
                      </div>
                      </div>
                      </footer>
 </div>
 <div class="popup-modal shadow" data-popup-modal="one">
 <div class="popup-modal__close">
X
 </div>

 </div>
<!-- </form> -->
    <!-- </div> -->
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
export default {
  name: 'footer',
  props: ['footer'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ]
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// footerWebsite.vue?771b9f18